'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bulletin-public', {
      url: '/public/bulletin',
      template: '<bulletin-public></bulletin-public>'
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/list/public/bulletin-public.routes.js